import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/userInfo'
import meta from './modules/meta'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    meta,
  }
})
